import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sg_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("sg_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("sg_user", JSON.stringify(r.data)); })
      .catch((err) => {
        // Only force-logout on auth errors. Network / 5xx might be transient
        // (e.g. preview pod restart) — keep the cached user so the UI stays usable.
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("sg_token");
          localStorage.removeItem("sg_user");
          setUser(null);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const loginPhone = async ({ phone, otp_code, password }) => {
    const { data } = await api.post("/auth/phone/login", { phone, otp_code, password });
    localStorage.setItem("sg_token", data.token);
    localStorage.setItem("sg_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const signupPhone = async (payload) => {
    const { data } = await api.post("/auth/phone/signup", payload);
    if (data.token) {
      localStorage.setItem("sg_token", data.token);
      localStorage.setItem("sg_user", JSON.stringify(data.user));
      setUser(data.user);
    }
    return data; // {token, user, pending_approval, message?}
  };

  const logout = () => {
    localStorage.removeItem("sg_token");
    localStorage.removeItem("sg_user");
    setUser(null);
    window.location.href = "/login";
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("sg_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, loginPhone, signupPhone, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
